"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProblemSchema = exports.PublicDepositAddressSchema = exports.PublicDepositAddressAssetSchema = exports.PublicDepositAddressRequestSchema = exports.AssetSymbolSchema = exports.ChainCodeInputSchema = exports.ChainCodeSchema = void 0;
const zod_1 = require("zod");
const wallet_1 = require("./wallet");
/** CCex chain code from the catalogue (`tron`, `ethereum`). */
exports.ChainCodeSchema = zod_1.z
    .string()
    .min(1)
    .max(32)
    .regex(/^[a-z_]+$/);
/**
 * Chain code as a partner sends it: whitespace and letter case are normalised (`" TRON "` -> `tron`).
 * The checks before `.toLowerCase()` are what the OpenAPI document shows for the request (`io: 'input'`).
 */
exports.ChainCodeInputSchema = zod_1.z
    .string()
    .trim()
    .min(1)
    .max(32)
    .regex(/^[A-Za-z_]+$/)
    .toLowerCase()
    .pipe(exports.ChainCodeSchema);
/** Currency symbol as shown in the catalogue (`USDT`); matched case-insensitively. */
exports.AssetSymbolSchema = zod_1.z.string().trim().min(1).max(16);
exports.PublicDepositAddressRequestSchema = zod_1.z.object({
    chain: exports.ChainCodeInputSchema.describe('CCex chain code, for example `tron` or `ethereum`; case-insensitive.'),
    asset: exports.AssetSymbolSchema.optional().describe('Symbol of the currency the partner will send, case-insensitive (`USDT`). When present, the request fails with `ASSET_NOT_SUPPORTED` unless that currency is enabled for this user on this chain, and `assets` in the response contains only that currency.'),
});
exports.PublicDepositAddressAssetSchema = zod_1.z.object({
    code: zod_1.z.string(),
    symbol: zod_1.z.string(),
    contractAddress: zod_1.z.string().nullable(),
    decimals: zod_1.z.int().min(0).max(30),
    /** Atomic units (10^-decimals), as a decimal string. */
    minDeposit: wallet_1.AtomicAmountSchema,
});
exports.PublicDepositAddressSchema = zod_1.z.object({
    id: zod_1.z.uuid(),
    chain: exports.ChainCodeSchema,
    address: zod_1.z.string().min(1),
    createdAt: zod_1.z.iso.datetime(),
    assets: zod_1.z
        .array(exports.PublicDepositAddressAssetSchema)
        .describe("Currencies enabled for this user on this chain, in catalogue order, with the user's own `minDeposit`; anything else sent to the address is not credited."),
});
/** `application/problem+json` body every error answers with; only used to document the public API. */
exports.ProblemSchema = zod_1.z
    .object({
    type: zod_1.z.string(),
    title: zod_1.z.string(),
    status: zod_1.z.int(),
    code: zod_1.z.string(),
    detail: zod_1.z.string(),
    instance: zod_1.z.string(),
})
    .loose();
//# sourceMappingURL=public-api.js.map